import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { FilterTypes, ConditionValueTypes, ConditionValuesOperator, Filter, OptionTypes } from 'app/components/filters/types';
import { customFilterFieldPostfix } from 'app/components/filters/filters-panel/constants';
import { FilterNumber } from 'app/components/filters/filters-panel/filter-types/filter-number/filter-number';
import { AdvancedSearchTypes, FavouriteConditionValue, FavouriteCondition } from 'app/types-shared';
import { getValue } from 'app/components/filters/filters-panel/filter-types/get-value';
import { createNumberFieldCondition } from 'app/components/filters/filters-panel/filter-types/filter-number/create-number-field-condition';
import { getOptionTypeValue } from 'app/components/filters/filters-panel/option-type-value';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { getConditionForOperator } from 'app/components/filters/filters-panel/filter-types/get-condition';

export const numberFieldConfiguration = {
  [FilterTypes.NumberField]: filterConfiguration(
    FilterNumber,
    undefined,
    [customFilterFieldPostfix.number]
  )
};

export const getNumberConditionTypesValueData = (advancedField: AdvancedSearchTypes, conditionValueType: ConditionValueTypes) => {
  return {
    [ConditionValueTypes.numberSingle]: {
      operator: advancedField.valueOperator,
      dbFunction: advancedField.dbFunctionValue
    },

    [ConditionValueTypes.numberSingleLargerOrEqual]: {
      operator: { v: ConditionValuesOperator.largerOrEqual },
      dbFunction: advancedField.dbFunctionValue2
    },

    [ConditionValueTypes.numberSingleLess]: {
      operator: { v: ConditionValuesOperator.lessOrEqual },
      dbFunction: advancedField.dbFunctionValue2
    },

    [ConditionValueTypes.numberRange]: {
      operator: advancedField.valueOperator2,
      dbFunction: advancedField.dbFunctionValue2
    },

    [ConditionValueTypes.notSpecified]: {
      operator: advancedField.valueOperator3,
      dbFunction: advancedField.dbFunctionValue3
    }
  }[conditionValueType];
};

export const createNumberData = (filter: Filter, editingValues: any) => {
  let id = 1;
  const optionType = getOptionTypeValue(filter);
  const selector = !!getValue(filter, editingValues, customFilterFieldPostfix.number) || optionType;

  const value = createNumberFieldCondition(
    getValue(filter, editingValues, customFilterFieldPostfix.number),
    (favouriteConditionValue: FavouriteConditionValue, type?: ConditionValueTypes) => {
      return filter.advancedField && {
        id: id++,
        myValue: false,
        periodPredef: { v: 0 },
        ...favouriteConditionValue,
        ...getNumberConditionTypesValueData(filter.advancedField, Number(type))
      };
    },
    optionType
  );

  return { value: selector && value, selector };
};

export const numberFieldConditionMapper = (editingValues: any) => {
  return {
    [FilterTypes.NumberField]: (filter: Filter) => {
      const numberData = createNumberData(filter, editingValues);
      const originalCondition = numberData.selector && numberData.value && numberData.value[0]
        ? getConditionForOperator(filter.conditions, numberData.value[0].operator)
        : undefined;

      return numberData.selector ? [
        createFavouriteCondition(filter, numberData.value, originalCondition)
      ] : [];
    }
  };
};

export const numberFieldOptionType = (condition: FavouriteCondition) => {

  if (condition.values && condition.values.some(v => v.operator && v.operator.v === ConditionValuesOperator.empty)) {
    return {
      [FilterTypes.NumberField]: OptionTypes.NotSpecified
    };
  }

  return {
    [FilterTypes.NumberField]: OptionTypes.SpecificNumbersOrRanges
  };
};
